<div class="page-content">
  <div class="ibox ">
      <div class="ibox-body">
          <div class="iboxcontent">
              <h3>Post Job</h3>
              <div class="stepsnumber">
                  <span>Steps 1/5</span>
              </div>
          </div>

          <h6 class="heading-6">Job Details</h6>
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="row">
                <div class="col-sm-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Job title<span class="orangeText">*</span>  </label>
                        <input type="text" class="form-control text-capitalize" placeholder="Please enter job title" [(ngModel)]="userJobTitle" name="userJobTitle" id="userJobTitles" (ngModelChange)="search()" formControlName="jobTitle" maxlength="50"/>
                        <ul class="dropdown" *ngIf="show">
                            <li *ngFor="let message of jobList;let i=index;" (click)="selectedJobs(i);drop()">
                              <a href="javascript:void(0)">{{message.name}}</a> 
                              </li> 
                          </ul> 
                        <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('required') && showError">
                            *Please enter job title.
                        </div> 
                        <div class="text-danger" *ngIf="!form.controls['jobTitle'].hasError('required') && form.controls['jobTitle'].hasError('minLength') && showError || showErrorMin">
                            *Please enter minimum 2 characters in job title..
                        </div> 
                        <div class="text-danger" *ngIf="form.controls['jobTitle'].hasError('maxlength') && showError">
                            *Maximum length of the job title is 50.
                        </div> 
                    </div>
                    <div class="form-group" *ngIf="subCat">
                        <label>Specilization  </label> 
                        <ng-multiselect-dropdown  formControlName="subCategoryId" class="form-control noBorder px-0 subCatMulti" [placeholder]="'Select'" [settings]="dropdownSettings" [data]="allSubCat" [ngClass]="allSubCat.length == 0 ?'disabled':''"></ng-multiselect-dropdown>
                        <div class="text-danger" *ngIf="form.controls['subCategoryId'].hasError('required') && showError">
                            *Please select specilization.
                        </div> 
                    </div>
                    <div class="form-group">
                        <label>Select industry<span class="orangeText">*</span>  </label>
                        <select class="form-control" formControlName="industryId" name="selectedIndustry">
                            <option [ngValue]="null" [disabled]="true" >Enter</option>
                            <option *ngFor="let indus of allindus;let i=index" [value]="indus.id">{{indus.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['industryId'].hasError('required') && showError">
                            *Please select industry.
                        </div> 
                    </div>
                    <div class="form-group">
                        <label>Location Type<span class="orangeText">*</span>  </label>
                        <select class="form-control" formControlName="workPlaceLocation" (ngModelChange)="selectedLocation($event)">
                            <option disabled selected>Enter</option>
                            <option value="Onsite">Onsite</option>
                            <option value="Remote">Remote</option>
                            <option value="Hybrid">Hybrid</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['workPlaceLocation'].hasError('required') && showError">
                            *Please select location.
                        </div> 
                    </div>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Select category<span class="orangeText">*</span>  </label>
                        <select class="form-control" formControlName="categoryId" (change)="selectCategoryId($event)">
                            <option disabled selected>Enter</option>
                            <option *ngFor="let cat of allCat;let i=index" [value]="cat.id">{{cat.name}}</option>
                        </select>
                        <div class="text-danger" *ngIf="form.controls['categoryId'].hasError('required') && showError">
                            *Please select category.
                        </div> 
                    </div>
                    <div class="form-group mb-1">
                        <label> Company’s description <span class="orange">*</span></label>
                        <textarea type="text" class="form-control textAreaDiscription" placeholder="We have the vision of a world where each day is safer and more secure than the one before." formControlName="description" maxlength="1000"></textarea>
                        <p class="para5">{{form?.value?.description?.length}}/1000</p>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('required') && showError">
                            *Please Enter description.
                        </div>
                        <div class="text-danger" *ngIf="form.controls['description'].hasError('maxlength') && showError">
                            *Maximum length of 1000 characters. 
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="adressbox row" formArrayName="address"  *ngIf="showLocation">
                <label>Address<span class="orangeText">*</span>  </label>
                <div class="col-lg-6 col-sm-12 box" *ngFor="let add of getAddresses(); let i=index">
                    <div class="form-group" [formGroupName]="i">
                        <input type="text" class="form-control text-capitalize" placeholder="Columbia" formControlName="location">
                        <div class="close" (click)="deleteAdress(i)" *ngIf="showAddLocation">
                            <img src="../../../../../assets/images/ic_close.svg" class="ht">
                        </div>
                        <div class="choose" (click)="addMoreAddress(i)" *ngIf="showAddLocation">
                            <img src="assets/images/addskill.svg" class="ht">
                        </div>
                        <div class="text-danger" *ngIf="showLocation && showError && add.value.location == ''">
                            *Please select location address.
                        </div> 
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 col-lg-12 col-md-12">
                    <div class="form-group">
                        <label> Skills <span class="orangeText">*</span> </label>
                        <select class="form-control" (change)="selectedSkill($event)">
                            <option *ngFor="let message of skillList;let i=index;" [value]="i">{{message.name}} </option>
                        </select>
                        <ul class="addedskills pt-4" *ngIf="addedSkills.length > 0">
                            <li *ngFor="let skill of addedSkills; let i=index;"> {{skill.name}} <a href="javascript:void(0);" (click)="removeSkills(i)"> × </a> </li> 
                        </ul>
                        <div class="text-danger" *ngIf="form.controls['skillIds'].hasError('required') && showError">
                            *Please select skills.
                        </div> 
                    </div>

                    <div class="form-group">
                        <h6 class="heading-6">Employment type </h6>
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)" [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                    </div>


                    <div class="form-group">
                        <h6 class="heading-6">Schedule </h6>
                        <ul class="suggestedskills">
                            <li *ngFor="let sch of allSchedules;let i=index;" (click)="selectedSchedules(i,$event)" [ngClass]="sch.selected == true ? 'selected' : ''">{{sch.name}}</li>
                            <button class="showmore" *ngIf="allSchedules.length > 9">Show 10 more <img src="assets/images/showmore.svg"></button>
                        </ul>
                    </div>

                    <a href="javascript:void(0)" routerLink="/jobs/post-job" class="planbtn greyBtn">Back</a>
                    <input type="submit" value="Continue" class="planbtn fill"/>
                </div>
            </div>
          </form>
      </div>
  </div>
</div>